import { render } from "./YyPermission.vue?vue&type=template&id=2aca4016&scoped=true"
import script from "./YyPermission.vue?vue&type=script&lang=js"
export * from "./YyPermission.vue?vue&type=script&lang=js"

import "./YyPermission.vue?vue&type=style&index=0&id=2aca4016&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aca4016"]])

export default __exports__